import React, { useEffect } from 'react'
import { initDatadog } from 'ppbl/utils/datadogUtil'

type Props = {
  applicationId: string
  clientToken: string
  userId?: string
}

const DatadogInitializer: React.FC<Props> = ({ applicationId, clientToken, userId }) => {
  useEffect(() => {
    initDatadog({ applicationId, clientToken, userId })
  }, [])

  return null
}

export default DatadogInitializer
